/* eslint-disable */
import React from 'react';

export default function PortisIcon() {
  return (
    <svg width="60" height="60" viewBox="10 10 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M29.9995 25.9322V14L20.526 30.2712L29.9995 25.9322Z" fill="#6CB3DB"/>
        <path d="M30.0004 25.9322V14L39.4739 30.2712L30.0004 25.9322Z" fill="#4A6C9B"/>
        <path d="M29.9995 38.9491L20.526 32.4406L29.9995 27.8667L39.473 32.4406L29.9995 38.9491Z" fill="#133444"/>
        <path d="M29.9995 36.2372V25.9321L20.526 30.2711L29.9995 36.2372Z" fill="#3D5578"/>
        <path d="M30.0004 36.2372V25.9321L39.4739 30.2711L30.0004 36.2372Z" fill="#1A425A"/>
        <path d="M20 35.1524C20 33.8507 20.3509 32.6214 20.5263 32.4406L29.9998 38.949C29.9998 40.0338 29.7016 41.1818 28.9998 42.2666C26.8946 45.5208 23.1578 43.8304 21.5789 41.1185C20 38.4067 20 36.7795 20 35.1524Z" fill="#6CB3DB"/>
        <path d="M39.9999 35.1525C39.9999 33.8508 39.649 32.6215 39.4736 32.4407L30.0001 38.9491C30.0001 40.0339 30.2983 41.182 31 42.2667C33.1053 45.5209 36.842 43.8305 38.421 41.1186C39.9999 38.4068 39.9999 36.7796 39.9999 35.1525Z" fill="#4A6C9B"/>
        <path d="M25.7894 43.8306C28.9472 43.8306 29.9998 40.5763 29.9998 38.9492C29.9998 40.5763 31.0524 43.8306 34.2103 43.8306C36.3155 43.8306 37.8944 41.6611 38.4207 41.1187C36.8418 43.8306 33.7892 46.0001 29.9998 46.0001C26.2104 46.0001 23.1578 43.8306 21.5789 41.1187C22.1052 41.6611 23.6841 43.8306 25.7894 43.8306Z" fill="#509CBA"/>
    </svg>
  );
}
